import "react-native-gesture-handler";
import { Image, Pressable, StyleSheet, Text, View } from "react-native";
import Clipboard from "@react-native-clipboard/clipboard";
import {
  Color43C6A7,
  color_38E3C8,
  color_7CC3F9,
  color_B1A8FF,
  color_FF6E6E,
  ColorF6F6F6,
  white,
} from "../../assets/style/colors";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { UserSetting } from "../../components/setting";
import { closeRealm } from "../../realm";
import * as ImSdk from "../../../imsdk/api/index";
import { useStore } from "../../store/UserStore";
import { useAppNavigation } from "../navigation";
import { useWebNavigation } from "../../utils/WebNavigationHook";
import { Platform } from "react-native";
import { LeftView } from "../Chat/CListItem";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { showToast } from "../../components/Toast";
import { CommonModal } from "../../components/CommonModal";
import {
  Str_AccountSecurity,
  Str_Announcement,
  Str_Cancel,
  Str_Confirm,
  Str_ConfirmLogout,
  Str_CopySuc,
  Str_Logout,
  Str_LogOutAllAccount,
  Str_LogOutCurrentAccount,
  Str_OtherSetting,
  Str_PrivacySetting,
} from "../../language/string_res";
import { getUserName } from "../Chat/chat-helper";
import { useTranslation } from "react-i18next";
import { logout, reportRegistrationID } from "../../net/service";
import { hideLoading, showLoading } from "../../components/Loading";
import { JPushManager } from "../../utils/JPushManager";
import LinearGradient from "react-native-linear-gradient";
import SafeIcon from "../../assets/svg/ic_safe.svg";
import PrivacysIcon from "../../assets/svg/ic_privacys.svg";
import OtherIcon from "../../assets/svg/icon_other.svg";
import NotifyIcon from "../../assets/svg/icon_announcement.svg";
import LogoutIcon from "../../assets/svg/icon_logout.svg";
import QRIcon from "../../assets/svg/icon_qr.svg";
import CopyIcon from "../../assets/svg/icon_copy.svg";
import WhiteArrIcon from "../../assets/svg/ic_right_arrow_white.svg";
import { getAvatarByUser } from "../../utils/utils";
import { getUid } from "../../store/token";
import { CommonBottomModal } from "../CommonBottomModal";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { use } from "i18next";
import { setIgnoreAuthFail, setNotIgnoreAuthFail } from "../../../App";


export const Logout = (isAll: boolean) => {
  showLoading("");
  JPushManager.getRegistrationID()
    .then((registrationID) => {
      if (!registrationID || registrationID.length === 0) {
        return;
      }
      reportRegistrationID({ op: 1, registration_id: registrationID })
    })

  doLogout(isAll);
};

const doLogout = async (isAll: boolean) => {
  try {
    let otherAuth: { uid: number; token: string }[] = [];
    let auths: ImSdk.KKAuth[] = [];


    const im = ImSdk.getInstance();
    const authsResult = await im.getAuths();
    if (authsResult.error === undefined && authsResult.auths && authsResult.auths.length) {
      auths = authsResult.auths?.filter(v => v.uid && v.uid > 0 && v.uid !== getUid() && v.token && v.token.length > 0);
      if (isAll && auths && auths.length > 0) {
        otherAuth = auths.map(v => ({ uid: v.uid, token: v.token })) || []
      }
    }

    await setIgnoreAuthFail();
    const r1 = await ImSdk.getInstance().GetLastAuth();
    const r = await logout(otherAuth);
    if (r.code !== 0) {
      hideLoading();
      showToast(r.msg || "");
      setNotIgnoreAuthFail();
      return;
    }

    let vcode = "";
    if (r1.vcode && r1.vcode.length > 0) {
      vcode = r1.vcode;
    }

    if (!isAll && auths.length > 0) {
      await ImSdk.getInstance().delAuths(r1.uid);
      await AsyncStorage.setItem("arrow_switch_user", r1.uid + "");
      hideLoading();
      ImSdk.getInstance().global_emit("global_login", {
        global_login: auths[0],
      });
      setNotIgnoreAuthFail();
    } else {
      await ImSdk.getInstance().clearAuths();

      ImSdk.getInstance().global_emit("global_logout", {
        global_logout: { vcode: vcode, screen: "Login" },
      });

      closeRealm();
      hideLoading();
      setNotIgnoreAuthFail();
    }
  } catch (e) {
    hideLoading();
    setNotIgnoreAuthFail();
  }
};

const MineScreen = () => {
  const navigation = useAppNavigation();
  const webNavigate = useWebNavigation();
  const { state } = useStore();
  const user = state?.user;
  useTranslation();
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const auths = useRef<ImSdk.KKAuth[]>([]);
  const [modalVis, setModalVis] = useState(false)

  useEffect(() => {
    ImSdk.getInstance().getAuths().then((res) => {
      if (res.error === undefined && res.auths && res.auths.length) {
        auths.current = res.auths;
      }
    })
  }, [])

  useEffect(() => {
    console.log(`上传成功 222 MineScreen user?.avatar: ${user?.avatar}`);
  }, [user?.avatar])

  const onLoginOutTap = () => {
    if (auths.current.length > 1) {
      setModalVis(true)
    } else {
      setLogoutModalVisible(true);
    }
  }

  const handleClose = useCallback(() => {
    setModalVis(false)
  }, [])

  const handleLogOut = useCallback(() => {
    setModalVis(false)
    Logout(false)
  }, [])

  const handleLogOutAll = useCallback(() => {
    setModalVis(false)
    Logout(true)
  }, [])

  return (
    <View style={{ flex: 1, backgroundColor: ColorF6F6F6 }}>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <LinearGradient
          colors={[Color43C6A7, white]}
          start={{ x: 0, y: 0 }}
          end={{ x: 0, y: 1 }}
          style={{ height: 310, width: "100%", position: "absolute" }}
        />

        <Pressable
          style={[styles.userInfoContainer, { marginTop: 20 }]}
          onPress={() => {
            if (Platform.OS === "web") {
              webNavigate("PersonalDetails");
            } else {
              navigation.navigate("PersonalDetails");
            }
          }}
        >
          {user ? <LeftView left={getAvatarByUser(user)} size={60} /> : null}

          <View style={styles.userInfoTextContainer}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                numberOfLines={1}
                ellipsizeMode={"tail"}
                style={styles.userInfoName}
              >
                {getUserName(user)}
              </Text>
              {(user?.sex === "0" || user?.sex === "1") && (
                <Image
                  style={{
                    width: 16,
                    height: 16,
                    objectFit: "contain",
                    marginRight: 4,
                  }}
                  source={
                    user.sex === "0"
                      ? require("../../assets/image/icon_women.png")
                      : require("../../assets/image/icon_man.png")
                  }
                />
              )}
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginTop: 4,
              }}
            >
              <Text
                numberOfLines={1}
                ellipsizeMode={"tail"}
                style={styles.userInfoSignature}
              >
                ID：{user?.employee || ""}
              </Text>

              <Pressable
                style={{ marginStart: 6 }}
                onPress={() => {
                  Clipboard.setString(user?.employee || "");
                  showToast(Str_CopySuc);
                }}
              >
                <CopyIcon />
              </Pressable>
            </View>
          </View>
          <View
            style={{ flexDirection: "row", alignItems: "center", marginEnd: 0 }}
          >
            <Pressable
              onPress={() => {
                navigation.navigate("QRCodeScreen", { user: state?.user });
              }}
            >
              <QRIcon />
            </Pressable>
            <WhiteArrIcon
              style={{ marginStart: 15, marginEnd: 16 }}
              width={20}
              height={20}
            />
          </View>
        </Pressable>

        <View style={styles.settingsGroup}>
          <UserSetting
            name={Str_AccountSecurity}
            icon={<SafeIcon />}
            onClick={() => {
              if (Platform.OS === "web") {
                webNavigate("AccountSecuritySetting");
              } else {
                navigation.navigate("AccountSecuritySetting");
              }
            }}
            iconBackground={color_7CC3F9}
            style={[styles.settingItem, { marginTop: 0 }]}
          />

          <UserSetting
            name={Str_PrivacySetting}
            icon={<PrivacysIcon />}
            onClick={() => {
              if (Platform.OS === "web") {
                webNavigate("PrivacySetting");
              } else {
                navigation.navigate("PrivacySetting");
              }
            }}
            iconBackground={color_38E3C8}
            style={styles.settingItem}
          />

          <UserSetting
            name={Str_OtherSetting}
            icon={<OtherIcon />}
            onClick={() => {
              if (Platform.OS === "web") {
                webNavigate("OtherSetting");
              } else {
                navigation.navigate("OtherSetting");
              }
            }}
            iconBackground={color_B1A8FF}
            style={styles.settingItem}
          />

          <UserSetting
            name={Str_Announcement}
            icon={<NotifyIcon />}
            onClick={() => {
              if (Platform.OS === "web") {
                webNavigate("Announcement");
              } else {
                navigation.navigate("Announcement");
              }
            }}
            iconBackground={color_B1A8FF}
            style={styles.settingItem}
          />
        </View>

        <UserSetting
          name={Str_Logout}
          onClick={() => {
            onLoginOutTap()
          }}
          icon={<LogoutIcon />}
          iconBackground={color_FF6E6E}
          style={styles.settingItem}
        />

        <CommonModal
          title={Str_ConfirmLogout}
          content={"确定要退出登录吗？退出后需要重新登录。"}
          cancelText={Str_Cancel}
          confirmText={Str_Confirm}
          visible={logoutModalVisible}
          onConfirm={() => {
            setLogoutModalVisible(false);
            Logout(false);
          }}
          onClose={() => setLogoutModalVisible(false)}
        />

        <CommonBottomModal
          text1={Str_LogOutCurrentAccount}
          text2={Str_LogOutAllAccount}
          textStyle2={{ color: "red" }}
          click1={handleLogOut}
          click2={handleLogOutAll}
          close={handleClose}
          visible={modalVis} />
      </GestureHandlerRootView>

    </View>
  );
};

export default MineScreen;

const styles = StyleSheet.create({
  userInfoContainer: {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    paddingStart: 27,
    paddingEnd: 16,
  },

  userInfoTextContainer: {
    flexDirection: "column", // 设置为纵向布局
    flex: 1,
  },
  userInfoName: {
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "",
    color: white,
    marginRight: 4,
  },
  userInfoSignature: {
    fontSize: 14,
    color: white,
    fontWeight: "400",
    fontFamily: "",
  },
  settingContainer: {
    marginTop: 12,
    backgroundColor: white,
    paddingVertical: 2,
    borderRadius: 5,
  },
  settingsGroup: {
    width: "100%",
    maxWidth: 800,
    alignSelf: "center",
    marginTop: 40,
  },
  settingItem: {
    marginTop: 16,
    backgroundColor: white,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    marginHorizontal: 20,
    paddingVertical: 16,
    paddingHorizontal: 20,
    minHeight: 60,
  },
});
